import { create } from 'zustand';

// The shop's messages column stays open across pages and visits.
const PANEL_KEY = 'comm-panel';
const readPanel = () => {
	try {
		return localStorage.getItem(PANEL_KEY) === 'open';
	} catch {
		return false;
	}
};
const writePanel = open => {
	try {
		localStorage.setItem(PANEL_KEY, open ? 'open' : 'closed');
	} catch {
		/* storage unavailable: the column just won't be remembered */
	}
};

// What the Communication Center knows about the logged-in user right now:
// GET /comm/me (can they use it, unread total, switches) plus a counter that
// bumps on every real-time update so open screens know to refetch. For shops,
// also the left messages column: open or not, and which conversation.
export const useCommStore = create(set => ({
	me: null,
	version: 0,
	lastUpdate: null,
	panelOpen: readPanel(),
	panelConversationId: null,
	columnWidth: 0, // px the open column takes from the page (0 when hidden or full screen)
	setMe: me => set({ me }),
	bump: update => set(s => ({ version: s.version + 1, lastUpdate: update || null })),
	reset: () => set({ me: null, version: 0, lastUpdate: null }),
	openPanel: conversationId => {
		writePanel(true);
		set(s => ({
			panelOpen: true,
			panelConversationId: conversationId ?? s.panelConversationId,
		}));
	},
	closePanel: () => {
		writePanel(false);
		set({ panelOpen: false });
	},
	togglePanel: () =>
		set(s => {
			writePanel(!s.panelOpen);
			return { panelOpen: !s.panelOpen };
		}),
	setPanelConversation: id => set({ panelConversationId: id }),
	setColumnWidth: columnWidth => set({ columnWidth }),
}));
